import {forwardRef} from 'react'

import type {InputProps} from '@chakra-ui/react'

import {FormControl, FormLabel, Input} from '../../utils/chakraMonomorphic'

export interface FormInputProps extends InputProps {
  label: string
  labelFontSize?: string | string[]
  labelFontWeight?: string | string[]
  labelPaddingTop?: string | string[] | number
  labelPaddingLeft?: string | string[] | number
  labelPaddingBottom?: string | string[] | number
  labelPaddingRight?: string | string[] | number
  labelMarginBottom?: string | string[] | number
  id: string
}

export const FormInput = forwardRef<HTMLInputElement, FormInputProps>(
  (
    {
      label,
      labelFontSize = '2xl',
      labelFontWeight = 'normal',
      labelPaddingTop = '',
      labelPaddingLeft = '',
      labelPaddingBottom = '',
      labelPaddingRight = '',
      labelMarginBottom = '',
      id,
      ...rest
    },
    ref,
  ) => (
    <FormControl d='flex' flexDir='column'>
      <FormLabel
        htmlFor={id}
        fontSize={labelFontSize}
        fontWeight={labelFontWeight}
        paddingTop={labelPaddingTop}
        paddingLeft={labelPaddingLeft}
        paddingBottom={labelPaddingBottom}
        paddingRight={labelPaddingRight}
        marginBottom={labelMarginBottom}>
        {label}
      </FormLabel>
      <Input id={id} type='text' ref={ref} {...rest} />
    </FormControl>
  ),
)
FormInput.displayName = 'FormInput'
